module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/mercado-pago-logo-13611831388e62b836225770051e5bdf.svg";